<template>
    <div>

        <nav
            class="
                top-0
                absolute
                z-50
                w-full
                flex flex-wrap
                items-center
                justify-between
                px-2
                py-3
                bg-gradient-to-r
                from-blue-500
            "
        >
            <div
                class="
                    container
                    px-4
                    mx-auto
                    flex flex-wrap
                    items-center
                    justify-between
                "
            >
                <div
                    class="
                        w-full
                        relative
                        flex
                        justify-between
                        lg:w-auto lg:static lg:block lg:justify-start
                    "
                >
                    <a
                        class="
                            text-sm
                            font-bold
                            leading-relaxed
                            inline-block
                            mr-4
                            py-2
                            whitespace-nowrap
                            uppercase
                            text-white
                        "
                        href="https://tumbas.apps.undip.ac.id"
                        >tumbas.apps.undip.ac.id</a>
                    <button
                        class="
                            cursor-pointer
                            text-xl
                            leading-none
                            px-3
                            py-1
                            border border-solid border-transparent
                            rounded
                            bg-transparent
                            block
                            lg:hidden
                            outline-none
                            focus:outline-none
                        "
                        type="button"
                        v-on:click="toggleNavbar()"
                    >
                        <i class="text-white fas fa-bars"></i>
                    </button>
                </div>
                <div
                    class="
                        lg:flex
                        flex-grow
                        items-center
                        bg-white
                        rounded-md
                        lg:bg-transparent lg:shadow-none
                    "
                    v-bind:class="{ hidden: !showMenu, block: showMenu }"
                >
                    <!--
                    <ul class="flex flex-col lg:flex-row list-none mr-auto">
                        <li class="flex items-center">
                            <a
                                class="
                                    lg:text-white lg:hover:text-gray-300
                                    text-gray-800
                                    px-3
                                    py-4
                                    lg:py-2
                                    flex
                                    items-center
                                    text-xs
                                    uppercase
                                    font-bold
                                "
                                href="https://www.creative-tim.com/learning-lab/tailwind-starter-kit#/landing"
                                ><i
                                    class="
                                        lg:text-gray-300
                                        text-gray-500
                                        far
                                        fa-file-alt
                                        text-lg
                                        leading-lg
                                        mr-2
                                    "
                                ></i>
                                Dokumentasi</a
                            >
                        </li>
                    </ul>
                    -->
                    <ul class="flex flex-col lg:flex-row list-none lg:ml-auto">
                        <li
                            class="
                                flex
                                items-center
                                rounded-md
                                hover:bg-slate-800
                            "
                        >
                            <Link
                                :href="route('register')"
                                class="
                                    lg:text-white
                                    text-gray-800
                                    px-3
                                    py-4
                                    lg:py-2
                                    flex
                                    items-center
                                    text-xs
                                    uppercase
                                    font-bold
                                "
                                ><i
                                    class="
                                        lg:text-gray-300
                                        text-gray-500 text-lg
                                        leading-lg
                                        mr-2
                                        fa-solid fa-user-plus
                                    "
                                ></i>
                                Daftar
                            </Link>
                        </li>
                        <li
                            class="
                                flex
                                items-center
                                rounded-md
                                hover:bg-slate-800
                            "
                        >
                            <Link
                                :href="route('login')"
                                class="
                                    lg:text-white
                                    text-gray-800
                                    px-3
                                    py-4
                                    lg:py-2
                                    flex
                                    items-center
                                    text-xs
                                    uppercase
                                    font-bold
                                "
                            >
                                <i
                                    class="
                                        lg:text-gray-300
                                        text-gray-500 text-lg
                                        leading-lg
                                        mr-2
                                        fa-solid fa-unlock-keyhole
                                    "
                                ></i>
                                Login
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <main>
            <template>
                <DialogModal
                    id="modal-pengumuman"
                    :show="showModal"
                    content="Pengumuman"
                    @close="showModal = false"
                >
                    <template v-slot:title>
                        <strong>PENGUMUMAN PENDAFTARAN DRM (DAFTAR REKANAN MAMPU)</strong>
                    </template>
                    <template v-slot:content>
                        <div class="py-1 px-3 m-1 flex align-items-center flex-wrap">
                            <p align="justify">
                                Berkaitan dengan telah berlakunya Peraturan Rektor Universitas Diponegoro Nomor 8 Tahun 2023 tentang Tata Cara Pengadaan Barang/Jasa yang Dibiayai dari Dana Selain APBN, yang mana mengatur tentang Daftar Rekanan Mampu (DRM) yaitu daftar Penyedia yang telah memenuhi syarat kualifikasi dan memenuhi syarat kinerja yang ditetapkan, maka mulai tanggal 3 Maret 2025 sampai dengan 14 Maret 2025 dibuka pendaftaran Penyedia untuk diseleksi menjadi DRM.
                            </p>
                            <br>
                            <p align="justify">
                                Untuk itu bagi Penyedia dipersilahkan mendaftar melalui website:
                                <a href="http://tumbas.apps.undip.ac.id/" target="_blank">http://tumbas.apps.undip.ac.id/</a>
                            </p>
                            <br>
                            <p align="justify">
                                Penyedia yang telah mendapat konfirmasi dari admin, silahkan melanjutkan proses pendaftaran dengan mengisi form-form yang disediakan. Penyedia dimohon menyiapkan data dukung dokumen dalam bentuk softcopy untuk diunggah ke sistem tersebut untuk melengkapi proses pendaftarannya. Dokumen persyaratan kualifiasi dan kinerja serta pendukung yang sekurang kurangnya:
                            </p>
                            <br>
                            <ol class="list-decimal" align="justify">
                                <li>Nomor Induk Berusaha (NIB) yang masih berlaku.</li>
                                <li>Lampiran NIB yang menunjukkan keahlian.</li>
                                <li>Daftar minimal 5 (lima) kontrak yang pernah dilaksanakan beserta bukti Salinan kontrak dalam kurun waktu 4 (empat) tahun terakhir baik di lingkungan pemerintah maupun swasta, termasuk pengalaman sub kontrak dengan rekomendasi minimal baik dari pemberi kerja.</li>
                                <li>Daftar kepemilikan peralatan sesuai dengan keahlian.</li>
                                <li>Daftar pegawai dan/atau tenaga ahli tetap sesuai dengan kompetensi yang dibutuhkan (bukan dari Pegawai Undip).</li>
                                <li>Surat Pemberitahuan Tahunan (SPT) Badan beserta lampirannya minimal 1 (satu) tahun terakhir.</li>
                                <li>Rekening koran dengan saldo positif minimal dalam 3 (tiga) bulan terakhir.</li>
                                <li>Laporan keuangan audited tahun terakhir untuk perusahaan nonkecil.</li>
                                <li>Laporan keuangan unaudited tahun terakhir khusus untuk Usaha Mikro/Kecil.</li>
                                <li>Surat pernyataan ditandatangani Penyedia yang menyatakan tidak dalam pengawasan pengadilan, tidak sedang dalam proses atau ditetapkan pailit, kegiatan usahanya tidak sedang dihentikan dan/atau direksi yang bertindak untuk dan atas nama perusahaan tidak sedang dalam menjalani sanksi pidana.</li>
                            </ol>
                            <br>
                            <p>
                                Semarang, 3 Maret 2025
                                <br />
                                Kantor Pengadaan Barang dan Jasa Universitas Diponegoro
                            </p>
                        </div>
                        <button @click="showModal = false" class="bg-blue-500 text-white px-4 py-2 rounded">Close</button>
                    </template>
                </DialogModal>
                <DialogModal
                    id="modal-pengumuman2"
                    :show="showModal2"
                    content="Pengumuman2"
                    @close="showModal2 = false"
                >
                    <template v-slot:title>
                        <strong>PENGUMUMAN LANJUTAN DAFTAR REKANAN MAMPU UNDIP</strong>
                    </template>
                    <template v-slot:content>
                        <div class="py-1 px-3 m-1">
                            <p>
                                Berdasar telaah data yang ada pada sistem DRM, maka:
                            </p>
                            <ol class="list-decimal">
                                <li>Masa pendaftaran DRM telah dibuka kembali dan diperpanjang sampai tanggal 10 Januari 2024, melalui laman <a href="http://tumbas.apps.undip.ac.id/" target="_blank">http://tumbas.apps.undip.ac.id/</a>.</li>
                                <li>Kepada para Penyedia yang telah terverifikasi tahap pertama (melalui email dari admin) dimohon untuk segera melengkapi isian data yang diminta sesuai pengumuman sebelumnya dan mengunggah semua berkas.</li>
                                <li>Bagi Penyedia yang sudah mengunggah dokumen, namun belum semuanya, dimohon melengkapi berkas-berkas digital dokumen yang diminta.</li>
                                <li>Bagi Penyedia baru yang berminat, dimohon segera memulai proses pendaftarannya.</li>
                                <li>Hanya Penyedia yang mengunggah secara lengkap semua berkas-berkas digital dokumen yang akan diverifikasi oleh Tim Penilai.</li>
                                <li>Bagi Penyedia yang memerlukan panduan dalam pendaftaran dan pengunggahan berkas digital dapat menghubungi nomor telepon berikut ini (PIC: mas Anas atau mas Aun) atau datang langsung ke KPBJ Undip pada jam kerja.</li>
                            </ol>
                            <br>
                            <p>
                                <strong>Kantor Pengadaan Barang dan Jasa (KPBJ) Undip</strong><br>
                                Gedung Rektorat Widya Puraya sayap kanan Lt 1<br>
                                Jl. Prof. Sudarto, SH Kampus Undip Tembalang<br>
                                Telpon: (024) 76918617
                            </p>
                            <br>
                            <p>
                                Semarang, 18 Desember 2023<br>
                                Kantor Pengadaan Barang dan Jasa Universitas Diponegoro
                            </p>
                        </div>
                        <button @click="showModal2 = false" class="bg-blue-500 text-white px-4 py-2 rounded">Close</button>
                    </template>
                </DialogModal>

                <DialogModal
                    id="modal-pengumuman3"
                    :show="showModal3"
                    content="Pengumuman3"
                    @close="showModal3 = false"
                >
                    <template v-slot:title>
                        <strong>PENGUMUMAN SELEKSI DAFTAR REKANAN MAMPU(DRM)KHUSUS</strong>
                    </template>
                    <template v-slot:content>
                        <div class="py-1 px-3 m-1">
                            <ol class="list-decimal">
                               <li>
                                   Kriteria_DRM_Konstruksi_Twin_Tower_Pleburan -> <a class="text-blue-700" href="/storage/Kriteria_DRM_Konstruksi_Twin_Tower_Pleburan.pdf" target="_blank">Download</a>
                               </li>
                                <li>
                                    Kriteria_DRM_KONSULTAN_MK_Tower_Tembalang -> <a class="text-blue-700" href="/storage/Kriteria_DRM_KONSULTAN_MK_Tower_Tembalang.pdf" target="_blank">Download</a>
                                </li>
                                <li>
                                    Kriteria_DRM_KONSULTAN_MK_Twin_Tower_Pleburan -> <a class="text-blue-700" href="/storage/Kriteria_DRM_KONSULTAN_MK_Twin_Tower_Pleburan.pdf" target="_blank">Download</a>
                                </li>
                                <li>
                                    Kriteria_DRM_Kontraksi_Tower_Tembalang -> <a class="text-blue-700" href="/storage/Kriteria_DRM_Kontraksi_Tower_Tembalang.pdf" target="_blank">Download</a>
                                </li>
                            </ol>
                             </div>
                        <div class="py-1 px-3 m-1">
                            <pdf :src="'/storage/Pengumuman_Koran_DRM_Khusus.pdf'"/>
                        </div>
                        <button @click="showModal3 = false" class="bg-blue-500 text-white px-4 py-2 rounded">Close</button>
                    </template>
                </DialogModal>

            </template>
            <div
                class="
                    relative
                    pt-16
                    pb-32
                    flex
                    content-center
                    items-center
                    justify-center
                "
                style="min-height: 75vh"
            >
                <div
                    class="absolute top-0 w-full h-full bg-center bg-cover"
                    style="
                        background-image: url('https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=crop&amp;w=1267&amp;q=80');
                    "
                >
                    <span
                        id="blackOverlay"
                        class="w-full h-full absolute opacity-75 bg-black"
                    ></span>
                </div>
                <div class="container relative mx-auto">
                    <div class="items-center flex flex-wrap">
                        <div
                            class="
                                w-full
                                lg:w-6/12
                                px-4
                                ml-auto
                                mr-auto
                                text-center
                            "
                        >
                            <div class="pr-12">
                                <LogoApp></LogoApp>
                                <p class="mt-4 text-lg text-gray-300">
                                    TUMBAS merupakan aplikasi pengadaan barang dan jasa
                                    secara elektronik di Universitas Diponegoro
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="
                        top-auto
                        bottom-0
                        left-0
                        right-0
                        w-full
                        absolute
                        pointer-events-none
                        overflow-hidden
                    "
                    style="height: 70px"
                >
                    <svg
                        class="absolute bottom-0 overflow-hidden"
                        xmlns="http://www.w3.org/2000/svg"
                        preserveAspectRatio="none"
                        version="1.1"
                        viewBox="0 0 2560 100"
                        x="0"
                        y="0"
                    >
                        <polygon
                            class="text-gray-300 fill-current"
                            points="2560 0 2560 100 0 100"
                        ></polygon>
                    </svg>
                </div>
            </div>
            <section class="pb-20 bg-gray-300 -mt-24">
                <div class="container mx-auto px-4">
                    <div class="flex flex-wrap">
                        <div
                            class="
                                lg:pt-12
                                pt-6
                                w-full
                                md:w-4/12
                                px-4
                                text-center
                            "
                        >
                            <div
                                class="
                                    relative
                                    flex flex-col
                                    min-w-0
                                    break-words
                                    bg-white
                                    w-full
                                    mb-8
                                    shadow-lg
                                    rounded-lg
                                "
                            >
                                <div class="px-4 py-5 flex-auto">
                                    <div
                                        class="
                                            text-white
                                            p-3
                                            text-center
                                            inline-flex
                                            items-center
                                            justify-center
                                            w-12
                                            h-12
                                            mb-5
                                            shadow-lg
                                            rounded-full
                                            bg-red-400
                                        "
                                    >
                                        <i class="fas fa-award"></i>
                                    </div>
                                    <h6 class="text-xl font-semibold">
                                        Terbuka
                                    </h6>
                                    <p class="mt-2 mb-4 text-gray-600">
                                        Pengadaan yang baik harus jelas dan
                                        transparan supaya tercipta persaingan
                                        pengadaan barang atau jasa yang sehat.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="w-full md:w-4/12 px-4 text-center">
                            <div
                                class="
                                    relative
                                    flex flex-col
                                    min-w-0
                                    break-words
                                    bg-white
                                    w-full
                                    mb-8
                                    shadow-lg
                                    rounded-lg
                                "
                            >
                                <div class="px-4 py-5 flex-auto">
                                    <div
                                        class="
                                            text-white
                                            p-3
                                            text-center
                                            inline-flex
                                            items-center
                                            justify-center
                                            w-12
                                            h-12
                                            mb-5
                                            shadow-lg
                                            rounded-full
                                            bg-blue-400
                                        "
                                    >
                                        <i class="fas fa-retweet"></i>
                                    </div>
                                    <h6 class="text-xl font-semibold">
                                        Akuntabel
                                    </h6>
                                    <p class="mt-2 mb-4 text-gray-600">
                                        Pengadaan barang harus mencapai sasaran
                                        serta menekankan pada pertanggungjawaban
                                        pada proses pencapaian.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="pt-6 w-full md:w-4/12 px-4 text-center">
                            <div
                                class="
                                    relative
                                    flex flex-col
                                    min-w-0
                                    break-words
                                    bg-white
                                    w-full
                                    mb-8
                                    shadow-lg
                                    rounded-lg
                                "
                            >
                                <div class="px-4 py-5 flex-auto">
                                    <div
                                        class="
                                            text-white
                                            p-3
                                            text-center
                                            inline-flex
                                            items-center
                                            justify-center
                                            w-12
                                            h-12
                                            mb-5
                                            shadow-lg
                                            rounded-full
                                            bg-green-400
                                        "
                                    >
                                        <i class="fas fa-fingerprint"></i>
                                    </div>
                                    <h6 class="text-xl font-semibold">
                                        Transparan
                                    </h6>
                                    <p class="mt-2 mb-4 text-gray-600">
                                        Seluruh ketentuan yang ada serta
                                        informasi mengenai pengadaan barang dan
                                        jasa harus jelas dan dapat diketahui
                                        secara luas.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-wrap items-center mt-32">
                        <div class="w-full md:w-5/12 px-4 mr-auto ml-auto">
                            <div
                                class="
                                    text-gray-600
                                    p-3
                                    text-center
                                    inline-flex
                                    items-center
                                    justify-center
                                    w-16
                                    h-16
                                    mb-6
                                    shadow-lg
                                    rounded-full
                                    bg-gray-100
                                "
                            >
                                <i class="fas fa-user-friends text-xl"></i>
                            </div>
                            <h3
                                class="
                                    text-3xl
                                    mb-2
                                    font-semibold
                                    leading-normal
                                "
                            >
                                Tingkatkan Pengalaman Pengadaan Anda di tumbas.apps.undip.ac.id Bersama Tim Kami!
                            </h3>
                            <p
                                class="
                                    text-lg
                                    font-light
                                    leading-relaxed
                                    mt-4
                                    mb-4
                                    text-gray-700
                                "
                            >
                                Bekerja bersama tim kami di platform pengadaan tumbas.apps.undip.ac.id adalah suatu kebahagiaan. Kami sangat antusias untuk berkontribusi dan mendukung dalam berbagai aspek proyek dan tugas yang ada di platform ini. Kolaborasi yang sinergis dan efisien diharapkan dapat menghasilkan hasil yang luar biasa. Jika ada hal konkret yang perlu dibahas atau langkah yang perlu diambil, jangan ragu untuk memberitahu kami. Kami siap membantu dengan senang hati.
                            </p>
                            <p
                                class="
                                    text-lg
                                    font-light
                                    leading-relaxed
                                    mt-0
                                    mb-4
                                    text-gray-700
                                "
                            >
                                <strong>Terima kasih!</strong>
                            </p>
                            <a
                                href="https://tumbas.apps.undip.ac.id"
                                class="font-bold text-gray-800 mt-8"
                                >Kantor Pendagadan Barang dan Jasa </a
                            >
                        </div>
                        <div class="w-full md:w-4/12 px-4 mr-auto ml-auto">
                            <div
                                class="
                                    relative
                                    flex flex-col
                                    min-w-0
                                    break-words
                                    bg-white
                                    w-full
                                    mb-6
                                    shadow-lg
                                    rounded-lg
                                    bg-pink-600
                                "
                            >
                                <img
                                    alt="..."
                                    src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=crop&amp;w=1051&amp;q=80"
                                    class="w-full align-middle rounded-t-lg"
                                />
                                <blockquote class="relative p-8 mb-4">
                                    <svg
                                        preserveAspectRatio="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 583 95"
                                        class="absolute left-0 w-full block"
                                        style="height: 95px; top: -94px"
                                    >
                                        <polygon
                                            points="-30,95 583,95 583,65"
                                            class="text-pink-600 fill-current"
                                        ></polygon>
                                    </svg>
                                    <h4 class="text-xl font-bold text-white">
                                        Layanan Terbaik
                                    </h4>
                                    <p
                                        class="
                                            text-md
                                            font-light
                                            mt-2
                                            text-white
                                        "
                                    >
                                        Memberikan Pengalaman Unggul: Komitmen Kami pada Layanan Terbaik di tumbas.apps.undip.ac.id
                                    </p>
                                </blockquote>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="relative py-20">
                <div
                    class="
                        bottom-auto
                        top-0
                        left-0
                        right-0
                        w-full
                        absolute
                        pointer-events-none
                        overflow-hidden
                        -mt-20
                    "
                    style="height: 80px"
                >
                    <svg
                        class="absolute bottom-0 overflow-hidden"
                        xmlns="http://www.w3.org/2000/svg"
                        preserveAspectRatio="none"
                        version="1.1"
                        viewBox="0 0 2560 100"
                        x="0"
                        y="0"
                    >
                        <polygon
                            class="text-white fill-current"
                            points="2560 0 2560 100 0 100"
                        ></polygon>
                    </svg>
                </div>
                <div class="container mx-auto px-4">
                    <div class="items-center flex flex-wrap">
                        <div class="w-full md:w-4/12 ml-auto mr-auto px-4">
                            <img
                                alt="..."
                                class="max-w-full rounded-lg shadow-lg"
                                src="https://images.unsplash.com/photo-1555212697-194d092e3b8f?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=crop&amp;w=634&amp;q=80"
                            />
                        </div>
                        <div class="w-full md:w-5/12 ml-auto mr-auto px-4">
                            <div class="md:pr-12">
                                <div
                                    class="
                                        text-pink-600
                                        p-3
                                        text-center
                                        inline-flex
                                        items-center
                                        justify-center
                                        w-16
                                        h-16
                                        mb-6
                                        shadow-lg
                                        rounded-full
                                        bg-pink-300
                                    "
                                >
                                    <i class="fas fa-rocket text-xl"></i>
                                </div>
                                <h3 class="text-3xl font-semibold">
                                    Membangun Perusahaan yang Berkembang
                                </h3>
                                <p
                                    class="
                                        mt-4
                                        text-lg
                                        leading-relaxed
                                        text-gray-600
                                    "
                                >
                                    Kami bertekad membangun perusahaan yang berkembang melalui aplikasi pengadaan tumbas.apps.undip.ac.id, menjadi mitra terpercaya dalam perjalanan pertumbuhan perusahaan Anda. Aplikasi ini menyediakan solusi komprehensif untuk mengelola proses pengadaan dengan efisiensi, meliputi permintaan, penawaran, dan keputusan akhir. Dengan fitur terintegrasi dan kemampuan penyesuaian, aplikasi ini dapat diadaptasi sesuai identitas perusahaan Anda. Kami hadir untuk memastikan setiap langkah dalam perjalanan pertumbuhan perusahaan berjalan lancar dan efisien, sambil terus mengembangkan aplikasi ini demi kesuksesan Anda.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="pt-20 pb-48">
                <div class="container mx-auto px-4">
                    <div
                        class="flex flex-wrap justify-center text-center mb-24"
                    >
                        <div class="w-full lg:w-6/12 px-4">
                            <h2 class="text-4xl font-semibold">
                                Kantor Pengadaan Barang dan Jasa
                            </h2>
                            <p
                                class="
                                    text-lg
                                    leading-relaxed
                                    m-4
                                    text-gray-600
                                "
                            >
                                Kantor Pengadaan Barang dan Jasa (KPBJ) adalah unit kerja yang berada di bawah Rektorat Universitas Diponegoro yang mempunyai tugas melaksanakan pengadaan barang/jasa di lingkungan Universitas Diponegoro.
                            </p>
                        </div>
                    </div>
<!--                    <div class="flex flex-wrap">-->
<!--                        <div-->
<!--                            class="-->
<!--                                w-full-->
<!--                                md:w-6/12-->
<!--                                lg:w-3/12 lg:mb-0-->
<!--                                mb-12-->
<!--                                px-4-->
<!--                            "-->
<!--                        >-->
<!--                            <div class="px-6">-->
<!--                                <img-->
<!--                                    alt="..."-->
<!--                                    src="/img/team-1-800x800.jpg"-->
<!--                                    class="-->
<!--                                        shadow-lg-->
<!--                                        rounded-full-->
<!--                                        max-w-full-->
<!--                                        mx-auto-->
<!--                                    "-->
<!--                                    style="max-width: 120px"-->
<!--                                />-->
<!--                                <div class="pt-6 text-center">-->
<!--                                    <h5 class="text-xl font-bold">-->
<!--                                        Ryan Tompson-->
<!--                                    </h5>-->
<!--                                    <p-->
<!--                                        class="-->
<!--                                            mt-1-->
<!--                                            text-sm text-gray-500-->
<!--                                            uppercase-->
<!--                                            font-semibold-->
<!--                                        "-->
<!--                                    >-->
<!--                                        Web Developer-->
<!--                                    </p>-->
<!--                                    <div class="mt-6">-->
<!--                                        <button-->
<!--                                            class="-->
<!--                                                bg-blue-400-->
<!--                                                text-white-->
<!--                                                w-8-->
<!--                                                h-8-->
<!--                                                rounded-full-->
<!--                                                outline-none-->
<!--                                                focus:outline-none-->
<!--                                                mr-1-->
<!--                                                mb-1-->
<!--                                            "-->
<!--                                            type="button"-->
<!--                                        >-->
<!--                                            <i-->
<!--                                                class="fab fa-twitter"-->
<!--                                            ></i></button-->
<!--                                        ><button-->
<!--                                            class="-->
<!--                                                bg-blue-600-->
<!--                                                text-white-->
<!--                                                w-8-->
<!--                                                h-8-->
<!--                                                rounded-full-->
<!--                                                outline-none-->
<!--                                                focus:outline-none-->
<!--                                                mr-1-->
<!--                                                mb-1-->
<!--                                            "-->
<!--                                            type="button"-->
<!--                                        >-->
<!--                                            <i-->
<!--                                                class="fab fa-facebook-f"-->
<!--                                            ></i></button-->
<!--                                        ><button-->
<!--                                            class="-->
<!--                                                bg-pink-500-->
<!--                                                text-white-->
<!--                                                w-8-->
<!--                                                h-8-->
<!--                                                rounded-full-->
<!--                                                outline-none-->
<!--                                                focus:outline-none-->
<!--                                                mr-1-->
<!--                                                mb-1-->
<!--                                            "-->
<!--                                            type="button"-->
<!--                                        >-->
<!--                                            <i class="fab fa-dribbble"></i>-->
<!--                                        </button>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div-->
<!--                            class="-->
<!--                                w-full-->
<!--                                md:w-6/12-->
<!--                                lg:w-3/12 lg:mb-0-->
<!--                                mb-12-->
<!--                                px-4-->
<!--                            "-->
<!--                        >-->
<!--                            <div class="px-6">-->
<!--                                <img-->
<!--                                    alt="..."-->
<!--                                    src="/img/team-2-800x800.jpg"-->
<!--                                    class="-->
<!--                                        shadow-lg-->
<!--                                        rounded-full-->
<!--                                        max-w-full-->
<!--                                        mx-auto-->
<!--                                    "-->
<!--                                    style="max-width: 120px"-->
<!--                                />-->
<!--                                <div class="pt-6 text-center">-->
<!--                                    <h5 class="text-xl font-bold">-->
<!--                                        Romina Hadid-->
<!--                                    </h5>-->
<!--                                    <p-->
<!--                                        class="-->
<!--                                            mt-1-->
<!--                                            text-sm text-gray-500-->
<!--                                            uppercase-->
<!--                                            font-semibold-->
<!--                                        "-->
<!--                                    >-->
<!--                                        Marketing Specialist-->
<!--                                    </p>-->
<!--                                    <div class="mt-6">-->
<!--                                        <button-->
<!--                                            class="-->
<!--                                                bg-red-600-->
<!--                                                text-white-->
<!--                                                w-8-->
<!--                                                h-8-->
<!--                                                rounded-full-->
<!--                                                outline-none-->
<!--                                                focus:outline-none-->
<!--                                                mr-1-->
<!--                                                mb-1-->
<!--                                            "-->
<!--                                            type="button"-->
<!--                                        >-->
<!--                                            <i-->
<!--                                                class="fab fa-google"-->
<!--                                            ></i></button-->
<!--                                        ><button-->
<!--                                            class="-->
<!--                                                bg-blue-600-->
<!--                                                text-white-->
<!--                                                w-8-->
<!--                                                h-8-->
<!--                                                rounded-full-->
<!--                                                outline-none-->
<!--                                                focus:outline-none-->
<!--                                                mr-1-->
<!--                                                mb-1-->
<!--                                            "-->
<!--                                            type="button"-->
<!--                                        >-->
<!--                                            <i class="fab fa-facebook-f"></i>-->
<!--                                        </button>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div-->
<!--                            class="-->
<!--                                w-full-->
<!--                                md:w-6/12-->
<!--                                lg:w-3/12 lg:mb-0-->
<!--                                mb-12-->
<!--                                px-4-->
<!--                            "-->
<!--                        >-->
<!--                            <div class="px-6">-->
<!--                                <img-->
<!--                                    alt="..."-->
<!--                                    src="/img/team-3-800x800.jpg"-->
<!--                                    class="-->
<!--                                        shadow-lg-->
<!--                                        rounded-full-->
<!--                                        max-w-full-->
<!--                                        mx-auto-->
<!--                                    "-->
<!--                                    style="max-width: 120px"-->
<!--                                />-->
<!--                                <div class="pt-6 text-center">-->
<!--                                    <h5 class="text-xl font-bold">-->
<!--                                        Alexa Smith-->
<!--                                    </h5>-->
<!--                                    <p-->
<!--                                        class="-->
<!--                                            mt-1-->
<!--                                            text-sm text-gray-500-->
<!--                                            uppercase-->
<!--                                            font-semibold-->
<!--                                        "-->
<!--                                    >-->
<!--                                        UI/UX Designer-->
<!--                                    </p>-->
<!--                                    <div class="mt-6">-->
<!--                                        <button-->
<!--                                            class="-->
<!--                                                bg-red-600-->
<!--                                                text-white-->
<!--                                                w-8-->
<!--                                                h-8-->
<!--                                                rounded-full-->
<!--                                                outline-none-->
<!--                                                focus:outline-none-->
<!--                                                mr-1-->
<!--                                                mb-1-->
<!--                                            "-->
<!--                                            type="button"-->
<!--                                        >-->
<!--                                            <i-->
<!--                                                class="fab fa-google"-->
<!--                                            ></i></button-->
<!--                                        ><button-->
<!--                                            class="-->
<!--                                                bg-blue-400-->
<!--                                                text-white-->
<!--                                                w-8-->
<!--                                                h-8-->
<!--                                                rounded-full-->
<!--                                                outline-none-->
<!--                                                focus:outline-none-->
<!--                                                mr-1-->
<!--                                                mb-1-->
<!--                                            "-->
<!--                                            type="button"-->
<!--                                        >-->
<!--                                            <i-->
<!--                                                class="fab fa-twitter"-->
<!--                                            ></i></button-->
<!--                                        ><button-->
<!--                                            class="-->
<!--                                                bg-gray-800-->
<!--                                                text-white-->
<!--                                                w-8-->
<!--                                                h-8-->
<!--                                                rounded-full-->
<!--                                                outline-none-->
<!--                                                focus:outline-none-->
<!--                                                mr-1-->
<!--                                                mb-1-->
<!--                                            "-->
<!--                                            type="button"-->
<!--                                        >-->
<!--                                            <i class="fab fa-instagram"></i>-->
<!--                                        </button>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div-->
<!--                            class="-->
<!--                                w-full-->
<!--                                md:w-6/12-->
<!--                                lg:w-3/12 lg:mb-0-->
<!--                                mb-12-->
<!--                                px-4-->
<!--                            "-->
<!--                        >-->
<!--                            <div class="px-6">-->
<!--                                <img-->
<!--                                    alt="..."-->
<!--                                    src="/img/team-4-470x470.png"-->
<!--                                    class="-->
<!--                                        shadow-lg-->
<!--                                        rounded-full-->
<!--                                        max-w-full-->
<!--                                        mx-auto-->
<!--                                    "-->
<!--                                    style="max-width: 120px"-->
<!--                                />-->
<!--                                <div class="pt-6 text-center">-->
<!--                                    <h5 class="text-xl font-bold">-->
<!--                                        Jenna Kardi-->
<!--                                    </h5>-->
<!--                                    <p-->
<!--                                        class="-->
<!--                                            mt-1-->
<!--                                            text-sm text-gray-500-->
<!--                                            uppercase-->
<!--                                            font-semibold-->
<!--                                        "-->
<!--                                    >-->
<!--                                        Founder and CEO-->
<!--                                    </p>-->
<!--                                    <div class="mt-6">-->
<!--                                        <button-->
<!--                                            class="-->
<!--                                                bg-pink-500-->
<!--                                                text-white-->
<!--                                                w-8-->
<!--                                                h-8-->
<!--                                                rounded-full-->
<!--                                                outline-none-->
<!--                                                focus:outline-none-->
<!--                                                mr-1-->
<!--                                                mb-1-->
<!--                                            "-->
<!--                                            type="button"-->
<!--                                        >-->
<!--                                            <i-->
<!--                                                class="fab fa-dribbble"-->
<!--                                            ></i></button-->
<!--                                        ><button-->
<!--                                            class="-->
<!--                                                bg-red-600-->
<!--                                                text-white-->
<!--                                                w-8-->
<!--                                                h-8-->
<!--                                                rounded-full-->
<!--                                                outline-none-->
<!--                                                focus:outline-none-->
<!--                                                mr-1-->
<!--                                                mb-1-->
<!--                                            "-->
<!--                                            type="button"-->
<!--                                        >-->
<!--                                            <i-->
<!--                                                class="fab fa-google"-->
<!--                                            ></i></button-->
<!--                                        ><button-->
<!--                                            class="-->
<!--                                                bg-blue-400-->
<!--                                                text-white-->
<!--                                                w-8-->
<!--                                                h-8-->
<!--                                                rounded-full-->
<!--                                                outline-none-->
<!--                                                focus:outline-none-->
<!--                                                mr-1-->
<!--                                                mb-1-->
<!--                                            "-->
<!--                                            type="button"-->
<!--                                        >-->
<!--                                            <i-->
<!--                                                class="fab fa-twitter"-->
<!--                                            ></i></button-->
<!--                                        ><button-->
<!--                                            class="-->
<!--                                                bg-gray-800-->
<!--                                                text-white-->
<!--                                                w-8-->
<!--                                                h-8-->
<!--                                                rounded-full-->
<!--                                                outline-none-->
<!--                                                focus:outline-none-->
<!--                                                mr-1-->
<!--                                                mb-1-->
<!--                                            "-->
<!--                                            type="button"-->
<!--                                        >-->
<!--                                            <i class="fab fa-instagram"></i>-->
<!--                                        </button>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
            </section>
            <section class="pb-20 relative block bg-gray-900">
                <div
                    class="
                        bottom-auto
                        top-0
                        left-0
                        right-0
                        w-full
                        absolute
                        pointer-events-none
                        overflow-hidden
                        -mt-20
                    "
                    style="height: 80px"
                >
                    <svg
                        class="absolute bottom-0 overflow-hidden"
                        xmlns="http://www.w3.org/2000/svg"
                        preserveAspectRatio="none"
                        version="1.1"
                        viewBox="0 0 2560 100"
                        x="0"
                        y="0"
                    >
                        <polygon
                            class="text-gray-900 fill-current"
                            points="2560 0 2560 100 0 100"
                        ></polygon>
                    </svg>
                </div>
                <div class="container mx-auto px-4 lg:pt-24 lg:pb-64">
                    <div class="flex flex-wrap text-center justify-center">
                        <div class="w-full lg:w-6/12 px-4">
                            <h2 class="text-4xl font-semibold text-white">
                                Potensi
                            </h2>
                            <p
                                class="
                                    text-lg
                                    leading-relaxed
                                    mt-4
                                    mb-4
                                    text-gray-500
                                "
                            >
                                Dengan antusiasme yang tinggi, kami melihat potensi besar untuk menjadi salah satu penyedia layanan pengadaan di lingkungan Universitas Diponegoro (Undip). Kami percaya bahwa kerjasama ini akan memberikan manfaat timbal balik yang positif. Dengan pengalaman kami dalam bidang ini dan komitmen untuk memberikan kualitas terbaik, kami siap berkontribusi dalam mendukung keberhasilan proses pengadaan Undip dan menjadi mitra yang dapat diandalkan dalam mencapai tujuan bersama.
                            </p>
                        </div>
                    </div>
                    <div class="flex flex-wrap mt-12 justify-center">
                        <div class="w-full lg:w-3/12 px-4 text-center">
                            <div
                                class="
                                    text-gray-900
                                    p-3
                                    w-12
                                    h-12
                                    shadow-lg
                                    rounded-full
                                    bg-white
                                    inline-flex
                                    items-center
                                    justify-center
                                "
                            >
                                <i class="fas fa-medal text-xl"></i>
                            </div>
                            <h6 class="text-xl mt-5 font-semibold text-white">
                                Excelent Services
                            </h6>
                            <p class="mt-2 mb-4 text-gray-500">
                                Some quick example text to build on the card
                                title and make up the bulk of the card's
                                content.
                            </p>
                        </div>
                        <div class="w-full lg:w-3/12 px-4 text-center">
                            <div
                                class="
                                    text-gray-900
                                    p-3
                                    w-12
                                    h-12
                                    shadow-lg
                                    rounded-full
                                    bg-white
                                    inline-flex
                                    items-center
                                    justify-center
                                "
                            >
                                <i class="fas fa-poll text-xl"></i>
                            </div>
                            <h5 class="text-xl mt-5 font-semibold text-white">
                                Grow your market
                            </h5>
                            <p class="mt-2 mb-4 text-gray-500">
                                Some quick example text to build on the card
                                title and make up the bulk of the card's
                                content.
                            </p>
                        </div>
                        <div class="w-full lg:w-3/12 px-4 text-center">
                            <div
                                class="
                                    text-gray-900
                                    p-3
                                    w-12
                                    h-12
                                    shadow-lg
                                    rounded-full
                                    bg-white
                                    inline-flex
                                    items-center
                                    justify-center
                                "
                            >
                                <i class="fas fa-lightbulb text-xl"></i>
                            </div>
                            <h5 class="text-xl mt-5 font-semibold text-white">
                                Launch time
                            </h5>
                            <p class="mt-2 mb-4 text-gray-500">
                                Some quick example text to build on the card
                                title and make up the bulk of the card's
                                content.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
<!--            <section class="relative block py-24 lg:pt-0 bg-gray-900">-->
<!--                <div class="container mx-auto px-4">-->
<!--                    <div class="flex flex-wrap justify-center lg:-mt-64 -mt-48">-->
<!--                        <div class="w-full lg:w-6/12 px-4">-->
<!--                            <div-->
<!--                                class="-->
<!--                                    relative-->
<!--                                    flex flex-col-->
<!--                                    min-w-0-->
<!--                                    break-words-->
<!--                                    w-full-->
<!--                                    mb-6-->
<!--                                    shadow-lg-->
<!--                                    rounded-lg-->
<!--                                    bg-gray-300-->
<!--                                "-->
<!--                            >-->
<!--                                <div class="flex-auto p-5 lg:p-10">-->
<!--                                    <h4 class="text-2xl font-semibold">-->
<!--                                        Want to work with us?-->
<!--                                    </h4>-->
<!--                                    <p-->
<!--                                        class="-->
<!--                                            leading-relaxed-->
<!--                                            mt-1-->
<!--                                            mb-4-->
<!--                                            text-gray-600-->
<!--                                        "-->
<!--                                    >-->
<!--                                        Complete this form and we will get back-->
<!--                                        to you in 24 hours.-->
<!--                                    </p>-->
<!--                                    <div class="relative w-full mb-3 mt-8">-->
<!--                                        <label-->
<!--                                            class="-->
<!--                                                block-->
<!--                                                uppercase-->
<!--                                                text-gray-700 text-xs-->
<!--                                                font-bold-->
<!--                                                mb-2-->
<!--                                            "-->
<!--                                            for="full-name"-->
<!--                                            >Full Name</label-->
<!--                                        ><input-->
<!--                                            type="text"-->
<!--                                            class="-->
<!--                                                border-0-->
<!--                                                px-3-->
<!--                                                py-3-->
<!--                                                placeholder-gray-400-->
<!--                                                text-gray-700-->
<!--                                                bg-white-->
<!--                                                rounded-->
<!--                                                text-sm-->
<!--                                                shadow-->
<!--                                                focus:outline-none focus:ring-->
<!--                                                w-full-->
<!--                                            "-->
<!--                                            placeholder="Full Name"-->
<!--                                            style="-->
<!--                                                transition: all 0.15s ease 0s;-->
<!--                                            "-->
<!--                                        />-->
<!--                                    </div>-->
<!--                                    <div class="relative w-full mb-3">-->
<!--                                        <label-->
<!--                                            class="-->
<!--                                                block-->
<!--                                                uppercase-->
<!--                                                text-gray-700 text-xs-->
<!--                                                font-bold-->
<!--                                                mb-2-->
<!--                                            "-->
<!--                                            for="email"-->
<!--                                            >Email</label-->
<!--                                        ><input-->
<!--                                            type="email"-->
<!--                                            class="-->
<!--                                                border-0-->
<!--                                                px-3-->
<!--                                                py-3-->
<!--                                                placeholder-gray-400-->
<!--                                                text-gray-700-->
<!--                                                bg-white-->
<!--                                                rounded-->
<!--                                                text-sm-->
<!--                                                shadow-->
<!--                                                focus:outline-none focus:ring-->
<!--                                                w-full-->
<!--                                            "-->
<!--                                            placeholder="Email"-->
<!--                                            style="-->
<!--                                                transition: all 0.15s ease 0s;-->
<!--                                            "-->
<!--                                        />-->
<!--                                    </div>-->
<!--                                    <div class="relative w-full mb-3">-->
<!--                                        <label-->
<!--                                            class="-->
<!--                                                block-->
<!--                                                uppercase-->
<!--                                                text-gray-700 text-xs-->
<!--                                                font-bold-->
<!--                                                mb-2-->
<!--                                            "-->
<!--                                            for="message"-->
<!--                                            >Message</label-->
<!--                                        ><textarea-->
<!--                                            rows="4"-->
<!--                                            cols="80"-->
<!--                                            class="-->
<!--                                                border-0-->
<!--                                                px-3-->
<!--                                                py-3-->
<!--                                                placeholder-gray-400-->
<!--                                                text-gray-700-->
<!--                                                bg-white-->
<!--                                                rounded-->
<!--                                                text-sm-->
<!--                                                shadow-->
<!--                                                focus:outline-none focus:ring-->
<!--                                                w-full-->
<!--                                            "-->
<!--                                            placeholder="Type a message..."-->
<!--                                        ></textarea>-->
<!--                                    </div>-->
<!--                                    <div class="text-center mt-6">-->
<!--                                        <button-->
<!--                                            class="-->
<!--                                                bg-gray-900-->
<!--                                                text-white-->
<!--                                                active:bg-gray-700-->
<!--                                                text-sm-->
<!--                                                font-bold-->
<!--                                                uppercase-->
<!--                                                px-6-->
<!--                                                py-3-->
<!--                                                rounded-->
<!--                                                shadow-->
<!--                                                hover:shadow-lg-->
<!--                                                outline-none-->
<!--                                                focus:outline-none-->
<!--                                                mr-1-->
<!--                                                mb-1-->
<!--                                            "-->
<!--                                            type="button"-->
<!--                                            style="-->
<!--                                                transition: all 0.15s ease 0s;-->
<!--                                            "-->
<!--                                        >-->
<!--                                            Send Message-->
<!--                                        </button>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </section>-->
        </main>
        <footer class="relative bg-gray-300 pt-8 pb-6">
            <div
                class="
                    bottom-auto
                    top-0
                    left-0
                    right-0
                    w-full
                    absolute
                    pointer-events-none
                    overflow-hidden
                    -mt-20
                "
                style="height: 80px"
            >
                <svg
                    class="absolute bottom-0 overflow-hidden"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                    <polygon
                        class="text-gray-300 fill-current"
                        points="2560 0 2560 100 0 100"
                    ></polygon>
                </svg>
            </div>
            <div class="container mx-auto px-4">
                <div class="flex flex-wrap">
                    <div class="w-full lg:w-6/12 px-4">
                        <h4 class="text-3xl font-semibold">
                            Universitas Diponegoro
<!--                            // alamat web undip-->
                            <a href="https://undip.ac.id">undip.ac.id</a>
                        </h4>
                        <h5 class="text-lg mt-0 mb-2 text-gray-700">
                            Jl. Prof. Soedarto, S.H. Tembalang, Semarang, Jawa
                            Tengah 50275
                        </h5>
                        <div class="mt-6">
                            <button
                                class="
                                    bg-white
                                    text-blue-400
                                    shadow-lg
                                    font-normal
                                    h-10
                                    w-10
                                    items-center
                                    justify-center
                                    align-center
                                    rounded-full
                                    outline-none
                                    focus:outline-none
                                    mr-2
                                    p-3
                                "
                                type="button"
                            >
                                <i class="flex fab fa-twitter"></i></button
                            ><button
                                class="
                                    bg-white
                                    text-blue-600
                                    shadow-lg
                                    font-normal
                                    h-10
                                    w-10
                                    items-center
                                    justify-center
                                    align-center
                                    rounded-full
                                    outline-none
                                    focus:outline-none
                                    mr-2
                                    p-3
                                "
                                type="button"
                            >
                                <i
                                    class="flex fab fa-facebook-square"
                                ></i></button
                            ><button
                                class="
                                    bg-white
                                    text-pink-400
                                    shadow-lg
                                    font-normal
                                    h-10
                                    w-10
                                    items-center
                                    justify-center
                                    align-center
                                    rounded-full
                                    outline-none
                                    focus:outline-none
                                    mr-2
                                    p-3
                                "
                                type="button"
                            >
                                <i class="flex fab fa-dribbble"></i></button
                            ><button
                                class="
                                    bg-white
                                    text-gray-900
                                    shadow-lg
                                    font-normal
                                    h-10
                                    w-10
                                    items-center
                                    justify-center
                                    align-center
                                    rounded-full
                                    outline-none
                                    focus:outline-none
                                    mr-2
                                    p-3
                                "
                                type="button"
                            >
                                <i class="flex fab fa-github"></i>
                            </button>
                        </div>
                    </div>
                    <div class="w-full lg:w-6/12 px-4">
                        <div class="flex flex-wrap items-top mb-6">
                            <div class="w-full lg:w-4/12 px-4 ml-auto">
                                <span
                                    class="
                                        block
                                        uppercase
                                        text-gray-600 text-sm
                                        font-semibold
                                        mb-2
                                    "
                                    >Useful Links</span
                                >
                                <ul class="list-unstyled">
                                    <li>
                                        <a
                                            class="
                                                text-gray-700
                                                hover:text-gray-900
                                                font-semibold
                                                block
                                                pb-2
                                                text-sm
                                            "
                                            href="https://undip.ac.id"
                                            >Website</a
                                        >
                                    </li>
                                </ul>
                            </div>
                            <div class="w-full lg:w-4/12 px-4">
                                <span
                                    class="
                                        block
                                        uppercase
                                        text-gray-600 text-sm
                                        font-semibold
                                        mb-2
                                    "
                                    >Other Resources</span
                                >
                                <ul class="list-unstyled">

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <hr class="my-6 border-gray-400" />
                <div
                    class="
                        flex flex-wrap
                        items-center
                        md:justify-between
                        justify-center
                    "
                >
                    <div class="w-full md:w-4/12 px-4 mx-auto text-center">
                        <div class="text-sm text-gray-600 font-semibold py-1">
                            Copyright © {{ date }} by
                            <a
                                href="https://www.creative-tim.com"
                                class="text-gray-600 hover:text-gray-900"
                                >Sistem Informasi UNDIP</a
                            >.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import { Link } from "@inertiajs/inertia-vue3";
import LogoApp from "@/Logo/LogoApp";
import DialogModal from "@/Jetstream/DialogModal.vue";
import pdf from "@/Components/Pdf.vue";


export default defineComponent({
    components: {pdf, Link, LogoApp , DialogModal},
    data() {
        return {
            showMenu: false,
            showModal: false,
            showModal2: false,
            showModal3: false,
            date: new Date().getFullYear(),
        };
    },
    methods: {
        toggleNavbar: function () {
            this.showMenu = !this.showMenu;
        },
    },
});
</script>
